<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')">首页</a-breadcrumb-item>
      <a-breadcrumb-item href="" @click.native="() => $router.back()">上一页</a-breadcrumb-item>
      <a-breadcrumb-item>体检数据对比分析</a-breadcrumb-item>
    </a-breadcrumb>

    <div class="c">
      <header>
        <a-radio-group v-model="version" @change="onChange">
          <a-radio-button value="1"> 旧版 </a-radio-button>
          <a-radio-button value="2"> 新版 </a-radio-button>
        </a-radio-group>

        <div class="checkbox">
          <a-checkbox @change="onChange" v-model="isAbnormal">
            查看异常值
          </a-checkbox>
          <a class="restore-btn" @click="saveImage('html2canvas', '体检数据对比分析')">
            下载
          </a>
        </div>
      </header>

      <div class="flex">
        <a-spin tip="下载中..." :spinning="spinning">
          <template>
            <a-table id="html2canvas" ref="html2canvas" :loading="loading" bordered :pagination="false"
              style="width: auto" :scroll="{ x: true }" :dataSource="tableData" :rowClassName="(record, index) => (index % 2 === 1 ? 'table-striped' : null)
                ">
              <a-table-column :data-index="item" v-for="item in columns" :key="item.key" :width="120">
                <span slot="title" @click="headerClick(item)" class="pointer">{{
                  item.title
                }}</span>
                <template slot-scope="text, record">
                  <span class="pointer" v-if="record[item.dataIndex].includes('↑')" style="color: #f56c6c"
                    @click="cellClick(record)">{{ record[item.dataIndex] }}</span>
                  <span class="pointer" v-else-if="record[item.dataIndex].includes('↓')" style="color: #2483ea"
                    :key="item.id" @click="cellClick(record)">{{ record[item.dataIndex] }}</span>
                  <span class="pointer" v-else @click="cellClick(record)">{{
                    record[item.dataIndex]
                  }}</span>
                </template>
              </a-table-column>
            </a-table>
          </template>
        </a-spin>
      </div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";

import { getHealthDataListNew, getHealthDataListNew2 } from "@/api/report";
const data = [];
const resultList = [];
export default {
  name: "",
  data() {
    return {
      version: "1",
      styleWidth: "auto",
      paginationTF: true,
      spinning: false,
      isAbnormal: true,
      tableData: [],
      resultList,
      columns: [],
      userInfo: {},
      loading: false,
    };
  },
  created() {
    this.userInfo =
      sessionStorage.getItem("userInfo") &&
      JSON.parse(sessionStorage.getItem("userInfo"));
    this.getHealthData();
  },

  methods: {
    /**点击表头 */
    headerClick(item) {
      if (item.physicalExamNo) {
        sessionStorage.setItem("i", item.physicalExamNo);
        sessionStorage.setItem("v", this.version);
        location.href = "./report.html";
      }
    },

    /**点击表格内容 */
    cellClick(item) {
      if (item.projectCode) {
        this.$router.push({
          path: "/curve",
          query: {
            itemCode: item.projectCode,
            certificateNo: this.certificateNo,
            version: this.version,
          },
        });
      }
    },
    dataURLToBlob(dataurl) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    },
    saveImage(divText, imgText) {
      let that = this;
      this.spinning = true;
      that.paginationTF = false;
      let canvasID = document.getElementsByClassName("ant-table-content")[0];
      console.log(document.getElementsByClassName("ant-table-content")[0]);
      var oDiv = document.getElementsByClassName("ant-table-wrapper")[0];
      var aaa = document.getElementsByClassName("ant-table-body")[0];
      oDiv.style.width = aaa.scrollWidth;
      oDiv.style.cssText = `width: ${aaa.scrollWidth}px`;
      let a = document.createElement("a");
      this.$nextTick(() => {
        html2canvas(canvasID, {
          scale: 2,
          width:
            document.getElementsByClassName("ant-table-body")[0].scrollWidth,
          windowWidth:
            document.getElementsByClassName("ant-table-content")[0].scrollWidth,
        }).then((canvas) => {
          let dom = document.body.appendChild(canvas);
          dom.style.display = "none";
          a.style.display = "none";
          document.body.removeChild(dom);
          let blob = that.dataURLToBlob(dom.toDataURL("image/png"));
          a.setAttribute("href", URL.createObjectURL(blob));
          //这块是保存图片操作  可以设置保存的图片的信息
          a.setAttribute("download", imgText + ".png");
          document.body.appendChild(a);
          a.click();
          URL.revokeObjectURL(blob);
          document.body.removeChild(a);
          oDiv.style.cssText = `width: auto`;
          that.paginationTF = true;
          that.spinning = false;
        });
      });
    },
    onChange(e) {
      this.getHealthData();
    },
    async getHealthData() {
      this.loading = true;
      this.certificateNo = this.userInfo.idCard
        ? this.userInfo.idCard
        : this.userInfo.passport;
      const params = {
        certificateNo: this.certificateNo, //证件号
        isAbnormal: this.isAbnormal ? 1 : 0, //是否异常 0-正常全部展示 1-只展示异常
      };
      const { code, data } =
        this.version == 2
          ? await getHealthDataListNew2(params)
          : await getHealthDataListNew(params);
      if (code == 200) {
        if (data.lineDataList.length > 0) {
          /***浏览数据***/
          //表头
          let columns = [
            {
              title: "项目名称",
              dataIndex: "projectName",
              key: "projectName",
              width: 200,
            },
          ];

          for (let index = 0; index < data.columnList.length; index++) {
            let item = {
              key: data.columnList[index].summaryDate,
              physicalExamNo: data.columnList[index].physicalExamNo,
              title: data.columnList[index].summaryDate,
              dataIndex: data.columnList[index].summaryDate,
              width: 150,
            };

            columns.push(item);
          }

          this.columns = columns;
          for (let j = 0; j < data.lineDataList.length; j++) {
            data.lineDataList[j].key = data.lineDataList[j].projectName + j;
          }
          this.tableData = data.lineDataList;

          this.showEmpty = false;
        } else {
          this.columns = [];
          this.tableData = []
          this.showEmpty = true;
        }
      } else {
        this.columns = [];
        this.tableData = []
        this.showEmpty = true;
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .table-striped td {
  background-color: #f0f2f5;
}

.c {
  padding: 30px 0;

  .checkbox {
    text-align: right;
  }
}

header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex {
  // display: flex;
  // justify-content: center;
  background: #fafafa;
  // margin-top: 20px;
  border-radius: 8px;
  margin-top: 20px;
}

.more-msg {
  margin: auto;
  text-align: center;
  cursor: pointer;
  color: #cfbfbf;
}

.list {
  overflow-y: auto;
  width: 325px;
  height: 680px;
  background: inherit;
  background-color: #ffffff;

  .list-item {
    display: flex;
    margin-bottom: 16px;
    border-radius: 8px;
    border-bottom: 1px solid #e8e8e8;
    align-items: center;
    cursor: pointer;

    img {
      width: 40px;
      height: 40px;
      margin: 12px;
    }

    .list-pro-name {

      .item-name,
      .item-time {
        margin: 4px 0;
      }
    }
  }
}

.upload-img {
  margin: 10px 0;
  padding-left: 10px;

  .camera-img {
    cursor: pointer;
  }
}

.sendBox {
  margin: 10px 0;
  width: 980px;
  padding-top: 5px;

  .ant-input {}

  .send-btn {
    margin-top: 12px;
    float: right;
  }
}

.scroll-box {
  padding: 10px 0;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background-color: #fcfcfc;
}

.scroll-wrapper {
  margin: auto;
  width: 980px;
  height: 520px; // 留一些空间给 打字的地方 和 header
  overflow: hidden; // 非常之关键
}

.actived {
  // border-bottom: 2px solid #3F86FF !important;
  // background-color: #ffffff !important;
  background: linear-gradient(90deg, #82b0ff 0%, #3e83f9 100%);
  box-shadow: 0px 4px 6px 0px rgba(160, 160, 160, 0.25);
}

h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 30px;
}

.pointer {
  cursor: pointer;
}
</style>
